import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon, MapPinIcon } from 'lucide-react';
import { TESTIMONIOS, avatarStyle } from '../data/landing';
export function TestimonialsSection() {
  return <section className="w-full bg-white py-10 sm:py-16" data-id="element-252" data-mp="1myzcbofrbx8o">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-253" data-mp="1my7oizsej3sy">
        <div className="mx-auto max-w-2xl text-center" data-id="element-254" data-mp="1r0b33xadaoig">
          <div className="flex items-center justify-center gap-1 text-yellow-400" data-id="element-255" data-mp="1d24df4fknutv">
            {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-6 w-6 fill-current" data-id="element-256" data-mp="1i2ipqyo7hqxp" data-mpi={i} />)}
          </div>
          <h2 className="mt-4 text-2xl font-black leading-tight text-neutral-900 sm:text-3xl lg:text-4xl" data-id="element-257" data-mp="1427vrmrlnw8b">
            Miles de familias argentinas ya cambiaron su forma de cocinar
          </h2>
          <p className="mt-3 text-base text-neutral-600 sm:text-lg" data-id="element-258" data-mp="2yg8tu5fbsf7c">
            Esto dicen de Norte a Sur del país los que ya tienen el MegaPack.
          </p>
        </div>

        <div className="mt-10 columns-1 gap-6 sm:columns-2 lg:columns-3" data-id="element-259" data-mp="2v1ax4nbdhejq">
          {TESTIMONIOS.map((t, i) => <motion.figure key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35
        }} className="mb-6 break-inside-avoid rounded-2xl border border-neutral-200 bg-neutral-50 p-5 shadow-sm" data-id="element-260" data-mp="2q314okh18s1t" data-mpi={i}>
              <div className="mb-2 flex items-center gap-1 text-yellow-400" data-id="element-261" data-mp="2c2ymsy8q5ymk">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-current" data-id="element-262" data-mp="2m1fl6g9ztfin" data-mpi={s} />)}
                <QuoteIcon className="ml-auto h-6 w-6 text-neutral-200" data-id="element-263" data-mp="2lyjnmt224suq" />
              </div>
              <blockquote className="text-sm leading-relaxed text-neutral-700" data-id="element-264" data-mp="2h45y37a2tfxz">
                "{t.texto}"
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3" data-id="element-265" data-mp="3shhuix3iawa4">
                <span className="h-11 w-11 shrink-0 rounded-full border-2 border-white bg-neutral-200 bg-no-repeat shadow" style={avatarStyle(t.avatarGrid, t.pos)} role="img" aria-label={`Foto de ${t.nombre}`} data-id="element-266" data-mp="3sjb0092dvagj" />
                <span className="min-w-0" data-id="element-267" data-mp="dcygs2furjlx">
                  <span className="block truncate text-sm font-bold text-neutral-900" data-id="element-268" data-mp="de9lc4h4gve3">
                    {t.nombre}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-neutral-500" data-id="element-269" data-mp="i9ovalc0e758">
                    <MapPinIcon className="h-3 w-3" data-id="element-270" data-mp="3grki3x5potma" /> {t.ciudad}
                  </span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}